<template>
  <transition name="menu-slide">
    <nav class="nav-menu">
      <div class="menu-bar">
        <div class="btn-close" @click.stop="changeMenu(false)">
          <img src="@/assets/img/menu-close.png">
        </div>
        <div class="audio-bar">
          <span>{{ $t("base.gramophone") }}</span>
          <div @click="changeAudio">
            <div class="play" v-if="!playing"></div>
            <div class="pause" v-else></div>
          </div>
        </div>
        <div class="btn-lng" @click="lngMenu = !lngMenu">{{lngNow}}</div>
      </div>
      <transition name="lngbar-silde">
        <ul class="list-lng" v-if="lngMenu">
          <li
            v-for="(value, key, index) in language"
            :key="index"
            @click="changeLng(key)"
          >
            {{ value }}
          </li>
        </ul>
      </transition>
      <ul class="list-menu">
        <li
          v-for="(item, index) in menus"
          :key="index"
          @click="changePage(item.path)"
        >
          {{ $t(`menu.${item.name}`) }}
        </li>
      </ul>
    </nav>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      lngMenu: false
    };
  },
  computed: {
    ...mapState(["menus", "audio", "language", "locale"]),
    lngNow() {
      return this.language[this.$i18n.locale];
    },
    playing() {
      return this.audio.inQueue ? this.audio.playing : false;
    }
  },
  methods: {
    ...mapMutations(["changeMenu"]),
    ...mapActions(["saveLocale", "changeLocale"]),
    changePage(path) {
      if (path) {
        this.$router.replace(path);
        this.changeMenu(false);
      }
    },
    changeAudio() {
      this.$emit("playAudio", !this.playing);
    },
    changeLng(lng) {
      this.$i18n.locale = lng;
      this.changeLocale(lng);
      this.lngMenu = false;
      this.changeMenu(false);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.nav-menu {
  @include full-box;
  z-index: 1000;
  height: 100%;
  padding-top: 3.25rem;
  overflow-y: scroll;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);

  @include hide-scrollbar;
}
.menu-bar {
  position: fixed;
  z-index: 1100;
  display: flex;
  top: 0;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.25rem;
  font-size: 0.875rem;
  background-color: $search;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);

  .btn-close {
    width: 3rem;
    height: 3rem;
    padding: 0.75rem;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    @include img-fluid;
  }

  .audio-bar {
    display: flex;
    align-items: center;

    span {
      padding-left: 1rem;
      padding-right: 0.5rem;
      color: rgba(255, 255, 255, 0.75);
    }

    .play,
    .pause {
      width: 2.5rem;
      height: 2.5rem;
    }

    .play::after {
      content: "";
      position: relative;
      left: 50%;
      margin-left: -0.125rem;
      @include center-y;
      display: block;
      width: 0px;
      height: 0px;
      border: 0.5rem transparent solid;
      border-left-color: #fff;
    }

    .pause {
      padding: 0.75rem 0;
      text-align: center;
      &::before,
      &::after {
        content: "";
        position: relative;
        display: inline-block;
        margin: 0 0.15rem;
        width: 0.25rem;
        height: 1rem;
        background-color: #fff;
      }
    }
  }

  .btn-lng {
    height: 3rem;
    padding-left: 1rem;
    padding-right: 1rem;
    line-height: 3rem;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
  }
}

.list-lng {
  position: fixed;
  z-index: 1020;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 1rem 0;
  margin: 0;
  background-color: $search;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);

  li {
    width: 30%;
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 0.875rem;
  }
}
.list-menu {
  padding-top: 0.75rem;
  padding-bottom: 1rem;
  margin: 0;

  li {
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 0.875rem;
  }
}
</style>
